<template>
   <div class="tabulation">
      <el-card class="chart-card">
         <div class="grabble" @keyup.enter="searchBtn">
            <el-input class="hunt" v-model="memberName" placeholder="请输入会员姓名" size="large" clearable />
            <el-input class="hunt" v-model="memberCode" placeholder="请输入会员编码" size="large" clearable />
            <el-input class="hunt" v-model="orderNumber" placeholder="请输入订单号" size="large" clearable />
            <el-select class="hunt" v-model="unionName" placeholder="请选择组织名称" size="large" clearable
               @click="multiple" @focus="closeIt" @clear="clearUnion" ref="selectIt" />
            <el-date-picker class="date-hunt" v-model="refundDateRange" type="daterange" range-separator="至"
               start-placeholder="请选择退款开始时间" end-placeholder="请选择退款结束时间" size="large"
               @change="handleRefundDateChange" style="width: 400px; flex: 0 0 400px; margin-right: 10px;" />
            <el-select class="hunt" v-model="paymentRefundStatus" placeholder="请选择退款状态" size="large" clearable>
               <el-option label="处理中" :value="0" />
               <el-option label="成功" :value="1" />
               <el-option label="失败" :value="2" />
               <el-option label="关闭" :value="3" />
            </el-select>
            <el-button style="margin-left: 10px" type="primary" size="large" @click="searchBtn" :loading="formative">
               <el-icon class="cancelgu">
                  <Search />
               </el-icon>搜索
            </el-button>
         </div>

         <div class="hint">统计 : {{ altogether }}条</div>

         <div class="feature-btn">
            <el-upload v-model:file-list="fileList" class="upload-demo" action :auto-upload="true"
               :show-file-list="false" name="excelFile" accept=".xlsx,.xls" :limit="1" :on-error="handleUploadError"
               :http-request="uploadRefundFile" ref="uploadRef" :disabled="uploadDisabled">
               <el-button style="margin-left: 10px" type="primary" size="default" :loading="uploadLoading"
                  :disabled="uploadDisabled">
                  <el-icon class="cancelgu">
                     <Upload />
                  </el-icon>批量退款
               </el-button>
            </el-upload>
            <el-button style="margin-left: 10px" type="primary" size="default" @click="downloadRefundTemplate">
               <el-icon class="cancelgu">
                  <Download />
               </el-icon>下载退款模板
            </el-button>
         </div>

			<el-table ref="tableRef" v-loading="listLoading" :data="filterTableData" style="width: 100%" row-key="id" border 
            scrollbar-always-on :header-cell-style="{ background: '#F5F7FA' }" :empty-text="texts">
            <el-table-column align="center" label="会员姓名" prop="name" min-width="130" :show-overflow-tooltip="true">
               <template #default="scope">
                  {{ emptyText(scope.row.name) }}
               </template>
            </el-table-column>
            <el-table-column label="会员编码" prop="username" align="center" min-width="150" :show-overflow-tooltip="true">
               <template #default="scope">
                  {{ emptyText(scope.row.username) }}
               </template>
            </el-table-column>
            <el-table-column label="所属工会" prop="unionName" align="center" min-width="160" :show-overflow-tooltip="true">
               <template #default="scope">
                  {{ emptyText(scope.row.unionName) }}
               </template>
            </el-table-column>
            <el-table-column label="所属部门" prop="departmentName" align="center" min-width="200" :show-overflow-tooltip="true">
               <template #default="scope">
                  {{ emptyText(scope.row.departmentName) }}
               </template>
            </el-table-column>
            <el-table-column label="订单号" prop="orderNumber" align="center" min-width="250" :show-overflow-tooltip="true">
               <template #default="scope">
                  {{ emptyText(scope.row.orderNumber) }}
               </template>
            </el-table-column>
            <el-table-column label="退款险种" prop="refundProductNames" align="center" min-width="250" :show-overflow-tooltip="true">
               <template #default="scope">
                  {{ emptyText(scope.row.refundProductNames) }}
               </template>
            </el-table-column>
            <el-table-column label="退款类型" prop="refundTypeText" align="center" min-width="140" :show-overflow-tooltip="true">
               <template #default="scope">
                  {{ emptyText(scope.row.refundTypeText) }}
               </template>
            </el-table-column>
            <el-table-column label="保障年度" prop="periodYear" align="center" min-width="120">
               <template #default="scope">
                  {{ emptyText(scope.row.periodYear) }}
               </template>
            </el-table-column>
            <el-table-column label="退款金额" prop="refundAmount" align="center" min-width="120">
               <template #default="scope">
                  {{ emptyText(scope.row.refundAmount) }}
               </template>
            </el-table-column>
            <el-table-column label="退款时间" align="center" min-width="170" :show-overflow-tooltip="true">
               <template #default="scope">
                  {{ formatTime(scope.row.refundTime) }}
               </template>
            </el-table-column>
            <el-table-column label="退款原因" prop="reason" align="center" min-width="220" :show-overflow-tooltip="true">
               <template #default="scope">
                  {{ emptyText(scope.row.reason) }}
               </template>
            </el-table-column>
            <el-table-column label="操作人" prop="operator" align="center" min-width="130" :show-overflow-tooltip="true">
               <template #default="scope">
                  {{ emptyText(scope.row.operator) }}
               </template>
            </el-table-column>
            <el-table-column label="退款状态" prop="paymentRefundStatus" align="center" min-width="120">
               <template #default="scope">
                  <span :style="{ color: refundStatusColor(scope.row.paymentRefundStatus) }">
                     {{ formatPaymentRefundStatus(scope.row.paymentRefundStatus) }}
                  </span>
               </template>
            </el-table-column>
         </el-table>

			<el-pagination :hide-on-single-page="true" layout="prev, pager, next,sizes" :page-sizes="[6, 12, 18, 24]"
            v-model:currentPage="currentPage" :page-size="pagesize" :total="paginationTotal"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </el-card>

      <div>
         <el-dialog v-model="visible" title="所属组织" width="500px" top="10vh" custom-class="organization-dialog" :close-on-click-modal="false" destroy-on-close>
            <el-tree :data="texture" :props="defaultProps" accordion @node-click="dendrogram" />
            <template #footer><el-button type="primary" @click="confirmUnion">确定</el-button></template>
         </el-dialog>
      </div>
   </div>
</template>

<script setup>
import { ref, onMounted, onActivated, nextTick } from "vue";
import { Download, Search, Upload } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import moments from "moment";
import qs from "qs";
import { downloadRefundExcelExample, importRefundExcel, queryRefundLogList, ZClist } from "../../utils/api";

const formative = ref(false);
const listLoading = ref(false);
const texts = ref("加载中");
const altogether = ref(0);
			const paginationTotal = ref(0);
const filterTableData = ref([]);
			const tableRef = ref(null);
			const refreshTableLayout = () => nextTick(() => tableRef.value?.doLayout?.());

const memberName = ref("");
const memberCode = ref("");
const unionName = ref("");
const unionId = ref("");
const pendingUnionName = ref("");
const pendingUnionId = ref("");
const orderNumber = ref("");
const refundDateRange = ref("");
const refundTimeFrom = ref("");
const refundTimeTo = ref("");
const paymentRefundStatus = ref("");
const currentPage = ref(1);
const pagesize = ref(6);
const fileList = ref([]);
const uploadRef = ref();
const uploadLoading = ref(false);
const uploadDisabled = ref(false);
const selectIt = ref();
const visible = ref(false);
const texture = ref([]);
const defaultProps = {
   children: "unionDtoList",
   label: "unionName",
};

const closeIt = () => {
   if (selectIt.value) {
      selectIt.value.blur();
   }
};

const multiple = () => {
   pendingUnionName.value = unionName.value;
   pendingUnionId.value = unionId.value;
   visible.value = true;
};

const clearUnion = () => {
   unionId.value = "";
   pendingUnionName.value = "";
   pendingUnionId.value = "";
};

const dendrogram = (node) => {
   pendingUnionName.value = node.unionName;
   pendingUnionId.value = node.unionId || node.id || "";
};

const confirmUnion = () => {
   unionName.value = pendingUnionName.value;
   unionId.value = pendingUnionId.value;
   visible.value = false;
};

const formatTime = (timestamp) => {
   if (typeof timestamp === "number") {
      return moments(timestamp * 1000).format("YYYY-MM-DD HH:mm:ss");
   }
   return timestamp || "-";
};

const formatPaymentRefundStatus = (status) => {
   const statusMap = {
      0: "处理中",
      1: "成功",
      2: "失败",
      3: "关闭",
   };
   return statusMap[status] || "-";
};

const refundStatusColor = (status) => {
   return Number(status) === 1 ? "#67c23a" : "red";
};

const handleRefundDateChange = (e) => {
   if (e !== null) {
      const startTime = new Date(e[0]).getTime() / 1000;
      const endTime = new Date(e[1]).getTime() / 1000;
      const endDate = moments(endTime * 1000).format().substring(0, 10);
      refundTimeFrom.value = startTime;
      refundTimeTo.value = new Date(endDate + " 23:59:59").getTime() / 1000;
   } else {
      refundTimeFrom.value = "";
      refundTimeTo.value = "";
   }
};

const buildParams = () => {
   return {
      page: currentPage.value,
      limit: pagesize.value,
      name: memberName.value,
      username: memberCode.value,
      unionId: unionId.value,
      orderNumber: orderNumber.value,
      refundTimeFrom: refundTimeFrom.value,
      refundTimeTo: refundTimeTo.value,
      paymentRefundStatus: paymentRefundStatus.value,
   };
};

const emptyText = (value) => {
   return value === "" || value === null || value === undefined ? "-" : value;
};

const list = () => {
   listLoading.value = true;
   altogether.value = 0;
   texts.value = "加载中";
   queryRefundLogList(qs.stringify(buildParams())).then((res) => {
      const data = res.data;
      if (data.code == 0) {
         const pageData = data.data.page || data.data;
         const listData = Array.isArray(pageData) ? pageData : pageData.list || [];
         filterTableData.value = listData;
         altogether.value = pageData.totalCount || pageData.total || listData.length;
			paginationTotal.value = altogether.value;
			texts.value = filterTableData.value.length === 0 ? "暂无数据" : "";
      } else {
         altogether.value = 0;
         texts.value = "暂无数据";
         ElMessage({
            message: data.msg,
            type: "error",
            center: true,
         });
      }
   }).catch(() => {
      texts.value = "暂无数据";
      ElMessage({
         message: "获取保障产品列表失败",
         type: "error",
         center: true,
      });
   }).finally(() => {
      listLoading.value = false;
      formative.value = false;
			refreshTableLayout();
   });
};

const searchBtn = () => {
   formative.value = true;
   currentPage.value = 1;
   list();
};

const handleSizeChange = (size) => {
   pagesize.value = size;
   currentPage.value = 1;
   list();
};

const handleCurrentChange = (size) => {
   currentPage.value = size;
   list();
};

const batchRefund = (file) => {
   const formData = new FormData();
   formData.append("excelFile", file);
   uploadDisabled.value = true;
   uploadLoading.value = true;
   importRefundExcel(formData).then((res) => {
      if (res.data.code == 0) {
         ElMessage({
            message: "导入成功",
            type: "success",
            center: true,
         });
         currentPage.value = 1;
         list();
      } else {
         ElMessage({
            message: res.data.msg || "导入失败",
            type: "error",
            center: true,
         });
      }
   }).catch(() => {
      ElMessage({
         message: "导入失败",
         type: "error",
         center: true,
      });
   }).finally(() => {
      uploadRef.value?.clearFiles();
      uploadDisabled.value = false;
      uploadLoading.value = false;
   });
};

const uploadRefundFile = (data) => {
   batchRefund(data.file);
};

const handleUploadError = () => {
   uploadRef.value?.clearFiles();
   uploadDisabled.value = false;
   uploadLoading.value = false;
   ElMessage({
      message: "导入失败",
      type: "error",
      center: true,
   });
};

const downloadRefundTemplate = () => {
   downloadRefundExcelExample().then((res) => {
      if (res.data.code == 0) {
         const url = res.data.data.excelExampleUrl || res.data.data.refundExcelExampleUrl;
         if (url) {
            const iframe = document.createElement("iframe");
            iframe.src = url;
            iframe.style.display = "none";
            document.body.appendChild(iframe);
            setTimeout(() => {
               document.body.removeChild(iframe);
            }, 1000);
         }
      } else {
         ElMessage({
            message: res.data.msg,
            type: "error",
            center: true,
         });
      }
   }).catch(() => {
      ElMessage({
         message: "下载退款模板失败",
         type: "error",
         center: true,
      });
   });
};

const lang = () => {
   ZClist().then((res) => {
      texture.value = res.data.data.manageUnionList || [];
   });
};

onMounted(() => {
   list();
   lang();
});

onActivated(() => {
   list();
});
</script>

<style lang="scss" scoped>
.chart-card::-webkit-scrollbar {
   display: none;
}

.chart-card {
   height: calc(100vh - 145px);
   overflow: auto;
}

::v-deep .el-table__empty-block {
   border-bottom: 1px solid #EBEEF5 !important;
}

.hint {
   font-size: 14px;
   color: #909399;
   margin-bottom: 15px;
}

.feature-btn {
   display: flex;
   justify-content: flex-end;
   margin-bottom: 10px;
}

::v-deep .el-table__body {
   margin-top: 0 !important;
   margin-bottom: 0 !important;
}

::v-deep .el-table__header {
   margin-top: 0 !important;
   margin-bottom: 0 !important;
}

.grabble {
   width: 100%;
   margin: 20px 0 15px 0;
   display: flex;
   align-items: center;
   flex-wrap: wrap;
   row-gap: 10px;

   .hunt {
      width: 15%;
      min-width: 160px;
      margin-right: 10px;
   }

   .date-hunt {
      width: 400px !important;
      min-width: 400px !important;
      flex: 0 0 400px;
      margin-right: 10px;
   }
}

.cancel {
   margin-right: 5px;
   font-weight: 400;
}

.cancelgu {
   margin-right: 6px;
   font-weight: bold;
}

.bulur {
   color: #409eff;
   border: none;
   --el-button-bg-color: none;
   --el-button-hover-bg-color: none;
   --el-button-hover-text-color: none;
}

.bulur:hover {
   color: #a0cfff;
}

::v-deep .el-table__inner-wrapper::before {
   width: 0;
}

::v-deep .el-table .el-table__cell {
   padding-top: 15px;
   padding-bottom: 15px;
}

.el-card.is-always-shadow {
   width: 95%;
   padding-left: 20px;
   padding-right: 20px;
   padding-bottom: 20px;
}

::v-deep .el-card__body {
   padding: 0;
}

.el-pagination {
   margin-top: 10px;
}

.tabulation {
   margin-top: 10px;
   display: flex;
   justify-content: center;
   align-items: center;
   margin-bottom: 10px;
}

::v-deep .el-select-dropdown__empty {
   display: none !important;
}
</style>

<style>
.el-popper {
   z-index: 10000 !important;
}

.el-select-dropdown__item.selected {
   font-weight: 500 !important;
}
</style>
